import { createContext, useContext, useState, useEffect } from 'react';

// Define preset margin values for better control
export const NAVBAR_MARGIN_PRESETS = {
  1: 0.75, // Compact (default)
  2: 1.5,  // Comfortable - increased from 1.25 for better distinction
  3: 2.0,  // Spacious - slightly increased from 1.75
  4: 2.75, // Extra spacious - increased from 2.5
  5: 3.75  // Maximum (for avoiding mobile conflicts) - increased from 3.5
};

// Create a context for navbar margin settings
const NavbarMarginContext = createContext({
  navbarMargin: NAVBAR_MARGIN_PRESETS[1], // Default is the compact setting
  navbarPreset: 1, // Track which preset is active
  setNavbarMargin: () => { },
  setNavbarPreset: () => { },
});

// Provider component
export function NavbarMarginProvider({ children }) {
  // Initialize state from localStorage or use default
  const getSavedPreset = () => {
    const savedPreset = localStorage.getItem('navbarMarginPreset');
    return savedPreset ? parseInt(savedPreset, 10) : 1;
  };

  const initialPreset = getSavedPreset();
  const [navbarMargin, setNavbarMargin] = useState(NAVBAR_MARGIN_PRESETS[initialPreset]);
  const [navbarPreset, setNavbarPreset] = useState(initialPreset);

  // Update localStorage when preset changes
  useEffect(() => {
    localStorage.setItem('navbarMarginPreset', navbarPreset.toString());
  }, [navbarPreset]);

  return (
    <NavbarMarginContext.Provider value={{
      navbarMargin,
      setNavbarMargin,
      navbarPreset,
      setNavbarPreset
    }}>
      {children}
    </NavbarMarginContext.Provider>
  );
}

// Custom hook to use the context
export function useNavbarMargin() {
  return useContext(NavbarMarginContext);
}
